import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServiceTemplate.css';

const ServiceTemplate = ({ 
  icon, 
  title, 
  subtitle, 
  description, 
  benefits, 
  process, 
  features,
  callToAction 
}) => {
  const navigate = useNavigate();

  return (
    <div className="service-page">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <span onClick={() => navigate('/')} className="breadcrumb-link">Home</span>
        <span className="breadcrumb-separator">›</span>
        <span onClick={() => { navigate('/'); setTimeout(() => { document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' }); }, 100); }} className="breadcrumb-link">Services</span>
        <span className="breadcrumb-separator">›</span>
        <span className="breadcrumb-current">{title}</span>
      </div>

      {/* Hero Section */}
      <div className="service-hero">
        <div className="service-hero-content">
          <div className="service-icon-large">{icon}</div>
          <h1 className="service-title">{title}</h1>
          <p className="service-subtitle">{subtitle}</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="service-content">
        {/* Overview */}
        <section className="service-section">
          <h2>Overview</h2>
          <p className="service-description">{description}</p>
        </section>

        {/* Benefits */}
        {benefits && benefits.length > 0 && (
          <section className="service-section benefits-section">
            <h2>Key Benefits</h2>
            <div className="benefits-grid">
              {benefits.map((benefit, index) => (
                <div key={index} className="benefit-card">
                  <div className="benefit-icon">✓</div>
                  <div className="benefit-content">
                    <h3>{benefit.title}</h3>
                    <p>{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* Features */}
        {features && features.length > 0 && (
          <section className="service-section">
            <h2>What We Offer</h2>
            <div className="features-list">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <span className="feature-bullet">●</span>
                  <span>{feature}</span>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* Process */}
        {process && process.length > 0 && (
          <section className="service-section process-section">
            <h2>Our Process</h2>
            <div className="process-steps">
              {process.map((step, index) => (
                <div key={index} className="process-step">
                  <div className="step-number">{index + 1}</div>
                  <div className="step-content">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {/* Call to Action */}
        <section className="service-cta">
          <h2>Ready to Get Started?</h2>
          <p>{callToAction || "Contact us today to discuss how we can help your business succeed."}</p>
          <button 
            className="btn btn-primary"
            onClick={() => { navigate('/'); setTimeout(() => { document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' }); }, 100); }}
          >
            Contact Us Now
          </button>
        </section>
      </div>
    </div>
  );
};

export default ServiceTemplate;

